import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import Providers from "store/Providers";
import { shouldUseLumioFavicon, isLumio } from "utils/platformStyle";

// Set favicon by platform style: lumio / empty / default → favicon_lumio, else → favicon_fbe
const faviconHref =
	(process.env.PUBLIC_URL || "") +
	(shouldUseLumioFavicon() ? "/favicon_lumio.ico" : "/favicon_fbe.ico");
const link = document.querySelector('link[rel="icon"]');
if (link) link.setAttribute("href", faviconHref);

// Set page title: Lumio when isLumio, else 袋理易
document.title = isLumio() ? "Lumio" : "袋理易";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<Providers>
			<App />
		</Providers>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
	onUpdate: (registration) => {
		// 当有新版本时，自动更新
		if (registration && registration.waiting) {
			registration.waiting.postMessage({ type: 'SKIP_WAITING' });
			window.location.reload();
		}
	},
	onSuccess: (registration) => {
		console.log('Service Worker registered successfully');
	}
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
